import * as palette from "@govlaunch/palette";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import LeftArrowIcon from "~/components/icons/LeftArrowIcon";
import { PreviewMode } from "~/src/components/product/getProductViewMode";

interface ITopLevelPreviewProductNavbarProps {
  productSlug: string;
  preview: PreviewMode | null | undefined;
  isEnrichedProfile: boolean;
}

export default function TopLevelPreviewProductNavbar({
  productSlug,
  preview,
  isEnrichedProfile,
}: ITopLevelPreviewProductNavbarProps) {
  if (!preview) {
    return null;
  }

  const viewingAsBasic = preview === "basic";

  const basicSwitchProps = {
    padding: 4,
    ":hover": {
      opacity: 0.8,
    },
  };
  const makersSwitchProps = {
    padding: 4,
    ":hover": {
      opacity: 0.8,
    },
  };
  const notSelectedProps = {
    color: palette.darkGray,
  };
  const selectedProps = {
    backgroundImage: "linear-gradient(97deg, #086BE5 10%, #28D094 60%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
  };

  return (
    <div
      css={{
        display: "flex",
        width: "100%",
        alignItems: "center",
      }}
    >
      <Link
        href="/products/[productSlug]/edit"
        as={`/products/${productSlug}/edit`}
        passHref={true}
        legacyBehavior={true}
      >
        <a
          css={{
            color: palette.darkGray,
            display: "flex",
            alignItems: "center",
            ":hover": {
              opacity: 0.7,
            },
          }}
        >
          <LeftArrowIcon width={20} height={10} />{" "}
          <span css={{ marginLeft: 4 }}>
            <FormattedMessage defaultMessage="Leave Preview" id="qJ60r9" />
          </span>
        </a>
      </Link>

      {!isEnrichedProfile && (
        <div
          css={{
            marginLeft: 12,
            background: `-webkit-linear-gradient(97deg, #086BE5 10%, #28D094 60%);`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            ":hover": {
              opacity: 0.8,
            },
          }}
        >
          <Link href="/makers" passHref={true} legacyBehavior={true}>
            <a>
              <FormattedMessage defaultMessage="Upgrade to Makers" id="FzYfeI" />
            </a>
          </Link>
        </div>
      )}

      <div
        css={{
          display: "flex",
          alignItems: "center",
          marginLeft: "auto",
        }}
      >
        <Link href={`/products/${productSlug}?preview=basic`} passHref={true} legacyBehavior={true}>
          <a
            css={
              viewingAsBasic
                ? {
                    ...basicSwitchProps,
                    ...(selectedProps as any),
                  }
                : {
                    ...basicSwitchProps,
                    ...notSelectedProps,
                  }
            }
          >
            {viewingAsBasic ? (
              <FormattedMessage defaultMessage="Viewing as Basic" id="IDIB6H" />
            ) : (
              <FormattedMessage defaultMessage="View as Basic" id="R4FHJW" />
            )}
          </a>
        </Link>

        <Link href={`/products/${productSlug}?preview=makers`} passHref={true} legacyBehavior={true}>
          <a
            css={
              viewingAsBasic
                ? {
                    ...makersSwitchProps,
                    ...notSelectedProps,
                  }
                : {
                    ...makersSwitchProps,
                    ...(selectedProps as any),
                  }
            }
          >
            {viewingAsBasic ? (
              <FormattedMessage defaultMessage="View as Makers" id="yy+KTi" />
            ) : (
              <FormattedMessage defaultMessage="Viewing as Makers" id="SagT9D" />
            )}
          </a>
        </Link>
      </div>
    </div>
  );
}
